import React from 'react';
import { alpha, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import CardContent from '@material-ui/core/CardContent';
import GavelIcon from '@material-ui/icons/Gavel';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import EventIcon from '@material-ui/icons/Event';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import SectionHeader from '../../CherrySoftware/components/SectionHeader';
import GlassCard from '../../CherrySoftware/components/GlassCard';
import IconBadge from '../../CherrySoftware/components/IconBadge';
import { whySystem } from '../annaSanelliaContent';

const LEGAL_ICONS = {
  gavel: GavelIcon,
  menuBook: MenuBookIcon,
  event: EventIcon,
  money: AttachMoneyIcon,
};

const WhySystem = () => {
  const theme = useTheme();

  return (
    <Box py={{ xs: 2, md: 3 }}>
      <SectionHeader
        overline={whySystem.overline}
        title={whySystem.title}
        subtitle={whySystem.subtitle}
        icon="verified"
        align="left"
        maxWidth={760}
      />

      <Grid container spacing={3}>
        {whySystem.items.map((item) => (
          <Grid item xs={12} sm={6} key={item.id}>
            <GlassCard data-aos="fade-up" accentPalette={item.color || 'primary'}>
              <CardContent sx={{ p: 3 }}>
                <Box mb={2}>
                  <IconBadge
                    icon={LEGAL_ICONS[item.icon] || GavelIcon}
                    color={item.color || 'primary'}
                    variant="gradient"
                    size={44}
                    rounded="12px"
                  />
                </Box>
                <Typography variant="h6" sx={{ fontWeight: 800, mb: 1.5, lineHeight: 1.3 }}>
                  {item.title}
                </Typography>
                <Typography color="textSecondary" sx={{ lineHeight: 1.75 }}>
                  {item.text}
                </Typography>
              </CardContent>
            </GlassCard>
          </Grid>
        ))}
      </Grid>

      <Box
        data-aos="fade-up"
        mt={4}
        p={{ xs: 3, md: 4 }}
        borderRadius={3}
        bgcolor={alpha(theme.palette.secondary.main, 0.08)}
        border={`1px solid ${alpha(theme.palette.secondary.main, 0.22)}`}
      >
        <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.55, maxWidth: 820 }}>
          {whySystem.closing}
        </Typography>
      </Box>
    </Box>
  );
};

export default WhySystem;
